import { ProgressLog } from '@/logger';
import { TransformStream } from '@yume-chan/stream-extra';

export class ProgressLogTransformStream extends TransformStream<Uint8Array, Uint8Array> {
  constructor(progressLog: ProgressLog, size: number) {
    let bytesUploaded = 0;
    super({
      transform: (chunk, controller) => {
        controller.enqueue(chunk);
        bytesUploaded += chunk.byteLength;
        progressLog.setProgress(bytesUploaded / size);
      },
      flush: () => {
        progressLog.complete();
      },
    });
  }
}
